// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","529":"dynamics","895":"download","974":"head"}[chunkId] + "." + {"18":"a65b18eb","529":"31b70a4f","895":"bf1b520e","974":"c457ab96"}[chunkId] + ".css";
};